import * as dt from "datatables.net-bs";
import * as dtResponsive from "datatables.net-responsive-bs";
import * as dtBtnBs from "datatables.net-buttons-bs";
import * as dtBtnHtml5 from "datatables.net-buttons/js/buttons.html5";
import * as dtBtnHtmlPrnt from "datatables.net-buttons/js/buttons.print";

//some overrides to customize datatables
$.fn.dataTable.Buttons.defaults.dom.button.className = "btn btn-sm btn-white";
$.fn.dataTable.ext.buttons.copyHtml5.text = function () {
  return '<i class="fa fa-clipboard" title="Copy"></i>';
};
$.fn.dataTable.ext.buttons.csvHtml5.text = function () {
  return '<i class="fa fa-regular fa-file-excel" title="Export"></i>';
};
$.fn.dataTable.ext.buttons.print.text = function () {
  return '<i class="fa fa-print" title="Print"></i>';
};

(function (cw, $, undefined) {
  cw.dtTools = {
    /**
     * Creates html table markup
     *
     * @param {[string] | [any]} columns Table columns, can be a datatables.net.columns array
     *
     * @return {string}
     */
    getTableMarkup: function (columns, tableClasses) {
      return cw.utility.getTableMarkup(columns, tableClasses);
    },
    /**
     * Handles sorting a date column and display
     *
     * @return {any} expected by datatables.net column.data
     */
    tableSortByDate: function (date, sortType, displayFormat) {
      return cw.utility.tableSortByDate(date, sortType, displayFormat);
    },
    /**
     * Update's referenced datatable's row based on matchingColumnName(assuming a flat object as rowData)
     *
     * @return {void}
     */
    addUpdateDataTableListing: function (dataTable, newObject, matchingColumnName, redrawTable) {
      return cw.utility.addUpdateDataTableListing(dataTable, newObject, matchingColumnName, redrawTable);
    },
    /**
     * Delete referenced datatable's row based on matchingColumnName(assuming a flat object as rowData)
     *
     * @return {void}
     */
    deleteDataTableListing: function (dataTable, matchingKeyValue, matchingColumnName, redrawTable) {
      return cw.utility.deleteDataTableListing(dataTable, matchingKeyValue, matchingColumnName, redrawTable);
    },
    /**
     * Get's referenced datatable's row based on matchingColumnName(assuming a flat object as rowData)
     *
     * @return {void}
     */
    getDataTableRowData: function (dataTable, matchingKeyValue, matchingColumnName) {
      return cw.utility.getDataTableRowData(dataTable, matchingKeyValue, matchingColumnName);
    },
    /**
     * Get all rows from referenced datatable
     *
     * @return {void}
     */
    getDataTableAllRowData: function (dataTable) {
      return cw.utility.getDataTableAllRowData(dataTable);
    },
    /**
     * Returns the next row after the one passed in (based on the current sort of the table)
     *
     * @return {any}
     */
    getDataTableNextRowData: function (dataTable, matchingKeyValue, matchingColumnName) {
      return cw.utility.getDataTableNextRowData(dataTable, matchingKeyValue, matchingColumnName);
    },
    /**
     * Returns the previous row after the one passed in (based on the current sort of the table)
     *
     * @return {any}
     */
    getDataTablePreviousRowData: function (dataTable, matchingKeyValue, matchingColumnName) {
      return cw.utility.getDataTablePreviousRowData(dataTable, matchingKeyValue, matchingColumnName);
    },
  };
})((window.cw = window.cw || {}), jQuery);
